import { Subject } from 'rxjs';
import { createContext, useContext } from "react";
export var loginSubject = new Subject();
export var member = null;
export var AuthContext = createContext({
    isAuthenticated: false,
    setIsAuthenticated: function (c) {
        console.log("setIsAuthenticated>>", c);
    },
});
export var useAuthContext = function () { return useContext(AuthContext); };
